export const textLabels = {
  ac_capacity: 'AC Capacity (MWac)',
  dc_capacity: 'DC Capacity (MWp)',
  row_length: 'Row Length (m)',
  number_of_rows: 'Number of Rows',
  modules_per_tables: 'Modules per Tables',
  width: 'Width (m)',
  height: 'Height (m)',
  area: 'Area (m²)',
  rows: 'Rows',
  trackers_per_row: 'Trackers per Row',
  tracker_width: 'Tracker Width (m)',
  tables_per_tracker: 'Tables per Tracker',
  modules_per_table: 'Modules per Table',
  not_cleaning: 'Not Cleaning',
  water_refill: 'Water Refill',
  fuel_refill: 'Fuel Refill',
  effective_cleaning: 'Effective Cleaning',
  maintenance: 'Maintenance',
  water: 'Water',
  fuel: 'Fuel',
  workers: 'Workers',
  bridges: 'Bridges',
  device: 'Device',
  brush: 'Brush',
  transition: 'Transition',
  battery: 'Battery',
  motor: 'Motor',
  yearly: 'Yearly',
  cleaning_opex: 'Cleaning Opex',
  capex: 'Capex',
  ac_soiling_no_clipping: 'AC production with soiling losses and without clipping losses',
  ac_soiling_clipping: 'AC production with soiling and clipping losses',
  ac_no_soiling_clipping: 'AC production without soiling losses and with clipping losses',
  dc_no_soiling: 'DC production without soiling losses',
  ac_soiling: 'AC production with soiling losses',
  ac_no_soiling: 'AC production without soiling losses',
  chart_export_failed: 'Chart export failed in this browser. Please try another format or browser.',
};
